import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { HTML_ATTRIBUTE_COOKIE_IDS } from "..";
/**
 * Listen to clicked content blockers and automatically delegate the click
 * event to the underlying element. This is especially useful for overlays of videos
 * so the user does not need to click twice.
 */

function delegateClickThroughUnblockedContent() {
  document.addEventListener(OPT_IN_CONTENT_BLOCKER, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _ref$detail, element, gotClicked, delegateClick, nextElementSibling, parentElement, parentElementNextSibling, _iterator, _step, _step$value, node, selectors, _iterator2, _step2, selector, fn;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$detail = _ref.detail, element = _ref$detail.element, gotClicked = _ref$detail.gotClicked;

              if (!gotClicked) {
                _context.next = 40;
                break;
              }

              nextElementSibling = element.nextElementSibling;
              parentElement = element.parentElement;
              parentElementNextSibling = parentElement === null || parentElement === void 0 ? void 0 : parentElement.nextElementSibling;
              _iterator = _createForOfIteratorHelper([[// Same element (= the blocked element)
              element, [// Ultimate Video (WP Bakery Page Builder)
              ".ultv-video__play"]], [// Next sibling element to the blocked content
              nextElementSibling, [// JetElements for Element
              ".jet-video__overlay"]], [// Next sibling element of parent of the blocked content
              parentElementNextSibling, [// Divi Page Builder
              ".et_pb_video_overlay"]]]);
              _context.prev = 6;

              _iterator.s();

            case 8:
              if ((_step = _iterator.n()).done) {
                _context.next = 31;
                break;
              }

              _step$value = _slicedToArray(_step.value, 2), node = _step$value[0], selectors = _step$value[1];

              if (!node) {
                _context.next = 29;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(selectors);
              _context.prev = 12;

              _iterator2.s();

            case 14:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 21;
                break;
              }

              selector = _step2.value;

              if (!node.matches(selector)) {
                _context.next = 19;
                break;
              }

              delegateClick = node;
              return _context.abrupt("break", 31);

            case 19:
              _context.next = 14;
              break;

            case 21:
              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](12);

              _iterator2.e(_context.t0);

            case 26:
              _context.prev = 26;

              _iterator2.f();

              return _context.finish(26);

            case 29:
              _context.next = 8;
              break;

            case 31:
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t1 = _context["catch"](6);

              _iterator.e(_context.t1);

            case 36:
              _context.prev = 36;

              _iterator.f();

              return _context.finish(36);

            case 39:
              // We delegate the click to an element, let's check if it is also blocked and listen to unblock
              if (delegateClick) {
                fn = function fn() {
                  return delegateClick.click();
                };

                if (delegateClick.hasAttribute(HTML_ATTRIBUTE_COOKIE_IDS)) {
                  delegateClick.addEventListener(OPT_IN_CONTENT_BLOCKER, fn, {
                    once: true
                  });
                } else {
                  fn();
                }
              }

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 33, 36, 39], [12, 23, 26, 29]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

export { delegateClickThroughUnblockedContent };